import React, { Component } from 'react'
import { classNames } from '../utils'

export default class SvgIcon extends Component<React.SVGProps<SVGSVGElement>> {
  render(): React.ReactNode {
    const { name, children, className, color: fill, ...props } = this.props
    return <svg className={ classNames('fc-icon', className,) } focusable="false" xmlns={ 'http://www.w3.org/2000/svg' } fill={ fill }
                icon-name={ name } color={ fill !== 'currentColor' ? fill : 'inherit' } { ...props } >
      { children }
    </svg>
  }
}
